import api from "./api";

export const getVillages = async (params) => {
  return api
    .get({
      endpoint: "/territory/villages",
      port: process.env.REACT_APP_PORT_TERRITORY,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
